// Archive page filters (vanilla JS)
(function(){
  document.addEventListener('DOMContentLoaded', function(){
    if(!document.body.classList.contains('archive-page')) return;

    const collection = document.getElementById('issue-collection');
    if(!collection) return;

    const cards = Array.from(collection.querySelectorAll('.issue-card'));
    const panels = {
      year: document.querySelector('.filter-chips[data-panel="year"]'),
      month: document.querySelector('.filter-chips[data-panel="month"]'),
      tag: document.querySelector('.filter-chips[data-panel="tag"]'),
      author: document.querySelector('.filter-chips[data-panel="author"]')
    };

    // Collect facets
    const years = new Set();
    const months = new Set(); // numeric ("01") found in cards
    const tags = new Set();
    const tagFreq = new Map();
    const monthNames = {"01":"January","02":"February","03":"March","04":"April","05":"May","06":"June","07":"July","08":"August","09":"September","10":"October","11":"November","12":"December"};

    function titleCase(slug){
      return slug.split('-').map(w=> w.length<=3 ? w.toUpperCase() : (w[0].toUpperCase()+w.slice(1))).join(' ')
        .replace(/\bAi\b/g,'AI');
    }
    const authors = new Set();
    const authorNameBySlug = new Map();

    cards.forEach(c => {
      years.add(c.dataset.year);
      months.add(c.dataset.month);
      (c.dataset.tags||'').split(',').filter(Boolean).forEach(t=>{tags.add(t); tagFreq.set(t,(tagFreq.get(t)||0)+1);});
      const slugs = (c.dataset.authors||'').split(',').filter(Boolean);
      const names = (c.dataset.authorNames||'').split(',');
      slugs.forEach((a,idx)=>{authors.add(a); if(names[idx]) authorNameBySlug.set(a, names[idx]);});
    });

    // State
    let active = { group:null, value:null };

    // Helpers
    function makeChip(label, value, group){
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.textContent = label;
      btn.dataset.value = value;
      btn.dataset.group = group;
      btn.addEventListener('click', ()=>{
        const panel = panels[group];
        const isAlreadyActive = btn.classList.contains('is-active');
        // Single-select; clicking active chip clears filter
        panel.querySelectorAll('button').forEach(b=>b.classList.remove('is-active'));
        if(isAlreadyActive){
          clearFilter();
        } else {
          btn.classList.add('is-active');
          applyFilter(group, value);
        }
      });
      return btn;
    }

    const clearBtn = document.querySelector('.clear-filter');

    function updateClearButton(){
      if(clearBtn){ clearBtn.hidden = !(active.group && active.value); }
    }

    function clearFilter(){
      active = { group:null, value:null };
      cards.forEach(c => c.classList.remove('is-dim','is-hidden'));
      updateMonthVisibility();
      const tl = document.querySelector('.timeline-months');
      if(tl){ tl.querySelectorAll('button').forEach(b=>b.classList.remove('is-active')); }
      updateClearButton();
      updateContextBar();
    }

    // Group cards by month into sections with sticky headers
    function groupByMonth(){
      const monthNames = {"01":"January","02":"February","03":"March","04":"April","05":"May","06":"June","07":"July","08":"August","09":"September","10":"October","11":"November","12":"December"};
      const map = new Map();
      cards.forEach(c=>{
        const key = `${c.dataset.year}-${c.dataset.month}`;
        if(!map.has(key)) map.set(key, []);
        map.get(key).push(c);
      });
      // Sort keys desc (newest first)
      const keys = Array.from(map.keys()).sort((a,b)=> b.localeCompare(a));
      // Clear container and rebuild
      collection.innerHTML = '';
      keys.forEach(key=>{
        const [y,m] = key.split('-');
        const section = document.createElement('section');
        section.className = 'month-section';
        section.dataset.key = key;
        const header = document.createElement('div');
        header.className = 'month-header';
        const h2 = document.createElement('h2');
        h2.className = 'month-title';
        h2.textContent = `${monthNames[m]} ${y}`;
        h2.dataset.originalTitle = h2.textContent;
        const sub = document.createElement('div');
        sub.className = 'month-sub';
        const count = map.get(key).length;
        const est = count * 4; // ~4 min per post
        sub.textContent = `${count} post${count!==1?'s':''} • ~${est} min read`;
        header.appendChild(h2);
        header.appendChild(sub);
        const grid = document.createElement('div');
        grid.className = 'month-grid';
        const items = map.get(key);
        items.forEach(el=> grid.appendChild(el));
        section.appendChild(header);
        section.appendChild(grid);
        collection.appendChild(section);
      });
    }

    function updateMonthVisibility(){
      const sections = Array.from(collection.querySelectorAll('.month-section'));
      sections.forEach(sec=>{
        const items = Array.from(sec.querySelectorAll('.issue-card'));
        const visible = items.some(i=>!i.classList.contains('is-hidden'));
        sec.classList.toggle('is-hidden', !visible);
      });
    }

    // Replace the pinned month header titles with a global context label when needed
    function setHeaderLabel(text){
      const headers = Array.from(document.querySelectorAll('.month-title'));
      headers.forEach(h=>{
        if(!h.dataset.originalTitle){ h.dataset.originalTitle = h.textContent; }
        h.textContent = text;
        h.classList.add('is-context');
      });
    }
    function restoreHeaderLabels(){
      const headers = Array.from(document.querySelectorAll('.month-title'));
      headers.forEach(h=>{
        if(h.dataset.originalTitle){ h.textContent = h.dataset.originalTitle; }
        h.classList.remove('is-context');
      });
    }

    function updateContextBar(){
      const el = document.getElementById('context-bar');
      const visibleCount = cards.filter(c=>!c.classList.contains('is-hidden')).length;
      const activeTab = document.querySelector('.filter-tabs .tab.is-active');
      const targetPanel = activeTab ? activeTab.dataset.filter : null;
      let label = '';
      if(active.group && active.value){
        if(active.group==='tag'){
          label = `Showing posts tagged “${titleCase(active.value)}”`;
        } else if(active.group==='author'){
          const name = authorNameBySlug.get(active.value) || active.value;
          label = `Browsing posts by ${name}`;
        } else if(active.group==='month'){
          const ref = cards.find(c=>!c.classList.contains('is-hidden') && c.dataset.month===active.value) || cards.find(c=>c.dataset.month===active.value);
          const y = ref ? ref.dataset.year : '';
          label = `Browsing by Month — ${monthNames[active.value] || active.value} ${y}`;
        } else if(active.group==='year'){
          label = `Browsing posts by year — ${active.value}`;
        }
      } else {
        // No specific filter active
        if(targetPanel === 'month'){
          label = 'Browsing by Month';
        } else if(targetPanel === 'year'){
          label = 'Browsing posts by year';
        } else if(targetPanel === 'tag'){
          label = 'Browsing posts by tag';
        } else if(targetPanel === 'author'){
          label = 'Browsing posts by contributor';
        } else {
          label = currentMonthLabel ? `Browsing by month — ${currentMonthLabel}` : 'All posts';
        }
      }
      if(label){ setHeaderLabel(`${label}`); } else { restoreHeaderLabels(); }
      if(el){ el.textContent = `${label} • ${visibleCount}`; }
    }

    // Observe month sections to update context bar while scrolling
    let currentMonthLabel = '';
    let monthObserver;
    function setupMonthObserver(){
      if(monthObserver) monthObserver.disconnect();
      const sections = Array.from(collection.querySelectorAll('.month-section'));
      const options = {root:null, rootMargin:'-30% 0px -50% 0px', threshold:[0.25,0.5,0.75]};
      monthObserver = new IntersectionObserver((entries)=>{
        // Pick the most visible entry
        const visible = entries
          .filter(e=>e.isIntersecting)
          .sort((a,b)=> (b.intersectionRatio - a.intersectionRatio));
        if(visible.length){
          const sec = visible[0].target;
          const titleEl = sec.querySelector('.month-title');
          const label = titleEl ? titleEl.textContent : '';
          // Only update when no explicit filter is active or when month tab is selected without a chip
          const activeTab = document.querySelector('.filter-tabs .tab.is-active');
          const targetPanel = activeTab ? activeTab.dataset.filter : null;
          if(!(active.group && active.value) && (targetPanel==='month' || !targetPanel)){
            currentMonthLabel = label;
            updateContextBar();
          }
        }
      }, options);
      sections.forEach(s=>monthObserver.observe(s));
    }

    function applyFilter(group, value){
      active = { group, value };
      const matches = [];
      cards.forEach(c => {
        let keep = true;
        if(group==='year') keep = (c.dataset.year===value);
        else if(group==='month') keep = (c.dataset.month===value);
        else if(group==='tag') keep = (c.dataset.tags||'').split(',').includes(value);
        else if(group==='author') keep = (c.dataset.authors||'').split(',').includes(value);
        c.classList.toggle('is-hidden', !keep);
        c.classList.toggle('is-dim', false);
        if(keep) matches.push(c);
      });
      // Horizontal scroll to first match without vertical jump
      // No horizontal scroll in vertical layout; just ensure sections reflect visibility
      updateMonthVisibility();
      const tl = document.querySelector('.timeline-months');
      if(tl){
        tl.querySelectorAll('button').forEach(b=>b.classList.toggle('is-active', group==='month' && b.dataset.month===value));
      }
      updateClearButton();
      updateContextBar();
    }

    function populate(){
      // Year chips
      Array.from(years).sort((a,b)=>b.localeCompare(a)).forEach(y=>panels.year.appendChild(makeChip(y, y, 'year')));
      // Month chips (only those present)
      const monthNames = {"01":"Jan","02":"Feb","03":"Mar","04":"Apr","05":"May","06":"Jun","07":"Jul","08":"Aug","09":"Sep","10":"Oct","11":"Nov","12":"Dec"};
      Array.from(months).sort().forEach(m=>panels.month.appendChild(makeChip(monthNames[m]||m, m, 'month')));
      // Tag chips (top 12 by frequency), label in Title Case
      function titleCase(slug){
        return slug.split('-').map(w=> w.length<=3 ? w.toUpperCase() : (w[0].toUpperCase()+w.slice(1))).join(' ')
          .replace(/\bAi\b/g,'AI');
      }
      Array.from(tags)
        .sort((a,b)=> (tagFreq.get(b)||0)-(tagFreq.get(a)||0))
        .slice(0,12)
        .forEach(t=>panels.tag.appendChild(makeChip(titleCase(t), t, 'tag')));
      // Author chips (label = name, value = slug)
      Array.from(authors).forEach(a=>{
        const label = authorNameBySlug.get(a) || a;
        panels.author.appendChild(makeChip(label, a, 'author'));
      });

      // Timeline: mark months that exist
      const tl = document.querySelector('.timeline-months');
      if(tl){
        tl.querySelectorAll('button').forEach(b=>{
          if(months.has(b.dataset.month)){
            b.classList.add('has-issue');
            b.addEventListener('click',()=>{
              const chip = panels.month.querySelector(`button[data-value=\"${b.dataset.month}\"]`);
              // sync chip UI
              panels.month.querySelectorAll('button').forEach(x=>x.classList.remove('is-active'));
              if(chip){ chip.classList.add('is-active'); }
              applyFilter('month', b.dataset.month);
            });
          }
        });
      }

      // Default tab/panel: whichever tab has .is-active in the DOM
      if(clearBtn){ clearBtn.addEventListener('click', clearFilter); }
      const activeTab = document.querySelector('.filter-tabs .tab.is-active');
      if(activeTab){
        const target = activeTab.dataset.filter;
        Object.entries(panels).forEach(([k,el])=>{ el.hidden = (k!==target); });
        // Do not auto-select any month; leave generic context until a chip is chosen
        updateContextBar();
      }

      // Tabs behavior
      const tabs = Array.from(document.querySelectorAll('.filter-tabs .tab'));
      tabs.forEach(t=>t.addEventListener('click',()=>{
        tabs.forEach(x=>{ x.classList.toggle('is-active', x===t); x.setAttribute('aria-selected', x===t ? 'true':'false'); });
        const target = t.dataset.filter;
        Object.entries(panels).forEach(([k,el])=>{ el.hidden = (k!==target); });
        // When switching tabs without a specific chip selected, ensure context bar reflects the mode
        if(!(active.group && active.value)) updateContextBar();
      }));
    }

    groupByMonth();
    populate();
    updateMonthVisibility();
    setupMonthObserver();
    updateContextBar();
  });
})();
